(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return;

    function panel() {
      return root.querySelector('.cart-drawer__panel');
    }

    function open() {
      root.classList.add('is-open');
      document.body.classList.add('cart-drawer-open');
      var p = panel();
      if (p) p.focus();
    }

    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
    }

    // Replace the drawer's inner content with freshly rendered section HTML and
    // sync the header count. Called after add / change.
    function renderFromSections(sections) {
      if (!sections || !sections['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var next = doc.querySelector('[data-cart-content]');
      var live = root.querySelector('[data-cart-content]');
      if (next && live) live.innerHTML = next.innerHTML;

      var count = doc.querySelector('[data-cart-count]');
      syncCount(count ? count.textContent.trim() : null);
    }

    function syncCount(value) {
      if (value === null) return;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = value;
      });
      document.querySelectorAll('[data-cart-bubble]').forEach(function (el) {
        if (value === '0') {
          el.setAttribute('hidden', '');
        } else {
          el.removeAttribute('hidden');
        }
      });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderFromSections(data.sections); });
    }

    // Expose a tiny API so the product form (and anything else) can drive it.
    window.CartDrawer = {
      open: open,
      close: close,
      renderFromSections: renderFromSections,
    };

    // GA4 dataLayer: begin_checkout. Reads the payload rendered next to the
    // checkout link, so it always reflects the current cart contents.
    function pushBeginCheckout(scope) {
      var node = scope.querySelector('[data-checkout-ecommerce]');
      if (!node) return;
      var ecommerce;
      try {
        ecommerce = JSON.parse(node.textContent);
      } catch (error) {
        return;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'begin_checkout', ecommerce: ecommerce });
    }

    // Enable/disable the checkout link based on the terms checkbox. Delegated so
    // it keeps working after the drawer content is re-rendered.
    document.addEventListener('change', function (event) {
      var checkbox = event.target.closest('[data-terms-checkbox]');
      if (!checkbox) return;
      var checkout = root.querySelector('[data-checkout]');
      if (!checkout) return;
      if (checkbox.checked) {
        checkout.classList.remove('is-disabled');
        checkout.removeAttribute('aria-disabled');
      } else {
        checkout.classList.add('is-disabled');
        checkout.setAttribute('aria-disabled', 'true');
      }
    });

    // Delegated clicks: works after content is swapped in.
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        open();
        return;
      }
      if (event.target.closest('[data-cart-close]')) {
        close();
        return;
      }

      // Block checkout while the terms haven't been accepted; otherwise fire the
      // begin_checkout event before the link navigates to /checkout.
      var checkout = event.target.closest('[data-checkout]');
      if (checkout) {
        if (checkout.classList.contains('is-disabled')) {
          event.preventDefault();
          return;
        }
        pushBeginCheckout(root);
        return;
      }

      var item = event.target.closest('[data-cart-item]');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var current = parseInt(item.getAttribute('data-quantity') || '1', 10);

      if (event.target.closest('[data-cart-remove]')) {
        changeLine(key, 0);
      } else if (event.target.closest('[data-cart-plus]')) {
        changeLine(key, current + 1);
      } else if (event.target.closest('[data-cart-minus]')) {
        changeLine(key, Math.max(0, current - 1));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    function swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-page-content]');
      var live = page.querySelector('[data-cart-page-content]');
      if (next && live) live.innerHTML = next.innerHTML;
    }

    // Dim the content and block further clicks while a change is in flight, so
    // it's clear something is happening (and to avoid overlapping requests).
    function setBusy(busy) {
      var content = page.querySelector('[data-cart-page-content]');
      if (!content) return;
      content.classList.toggle('opacity-50', busy);
      content.classList.toggle('pointer-events-none', busy);
    }

    function change(key, quantity) {
      setBusy(true);
      // The cart template's own `main` section can't be re-rendered through the
      // Section Rendering API (it returns null), so we only ask change.js for the
      // globally-rendered cart-drawer, then re-fetch /cart for the page content.
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          // Keep the drawer + header count in sync.
          if (window.CartDrawer) window.CartDrawer.renderFromSections(data.sections);
          // Re-fetch the cart page and swap its content in place.
          return fetch('/cart', { headers: { Accept: 'text/html' } })
            .then(function (r) { return r.text(); })
            .then(swap);
        })
        .finally(function () { setBusy(false); });
    }

    // Toggle the checkout button based on the terms checkbox. Delegated so it
    // survives the content being swapped after a quantity change.
    page.addEventListener('change', function (event) {
      var checkbox = event.target.closest('[data-terms-checkbox]');
      if (!checkbox) return;
      var button = page.querySelector('[data-checkout]');
      if (button) button.disabled = !checkbox.checked;
    });

    // GA4 dataLayer: begin_checkout, fired when the cart form submits to
    // checkout. The payload is rendered inside the form and swapped in with the
    // content, so it always reflects the current cart.
    page.addEventListener('submit', function (event) {
      if (!event.target.closest('[data-cart-checkout-form]')) return;
      var node = page.querySelector('[data-checkout-ecommerce]');
      if (!node) return;
      var ecommerce;
      try {
        ecommerce = JSON.parse(node.textContent);
      } catch (error) {
        return;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'begin_checkout', ecommerce: ecommerce });
    });

    page.addEventListener('click', function (event) {
      var item = event.target.closest('[data-line-item]');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var current = parseInt(item.getAttribute('data-quantity') || '1', 10);

      if (event.target.closest('[data-line-remove]')) {
        change(key, 0);
      } else if (event.target.closest('[data-line-plus]')) {
        change(key, current + 1);
      } else if (event.target.closest('[data-line-minus]')) {
        change(key, Math.max(0, current - 1));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var SCROLL_TRIGGER = 30;
    var P_GAP = 24; // px of breathing room the icons leave for P

    function setup(header) {
      if (!header || header.dataset.brandSplitInit) return;

      // Scroll animation is home-only; other pages spread the brands via CSS.
      if (!header.hasAttribute('data-brand-scroll')) return;

      var d = header.querySelector('.header__brand--d');
      var p = header.querySelector('.header__brand--p');
      if (!d || !p) return;

      header.dataset.brandSplitInit = 'true';

      var desktop = window.matchMedia('(min-width: 750px)');

      function measure() {
        if (!desktop.matches) {
          header.style.removeProperty('--d-shift');
          header.style.removeProperty('--p-shift');
          header.style.removeProperty('--p-space');
          return;
        }

        // Read base (untransformed) positions: getBoundingClientRect includes
        // transforms, so blank them out for the measurement, then restore.
        header.classList.add('header--measuring');
        var dr = d.getBoundingClientRect();
        var pr = p.getBoundingClientRect();
        header.classList.remove('header--measuring');

        // Settle both brands a fixed distance from the viewport edge rather than
        // from the content edge. The page margin shrinks from 60px to 20px below
        // 750px, so anchoring to the content edge made the letters overshoot past
        // the smaller margin (and off-screen) at narrow widths.
        var TARGET_INSET = 20; // px from the viewport edge
        var vw = document.documentElement.clientWidth;
        header.style.setProperty('--d-shift', (TARGET_INSET - dr.left) + 'px');
        header.style.setProperty('--p-shift', (vw - TARGET_INSET - pr.right) + 'px');
        header.style.setProperty('--p-space', pr.width + P_GAP + 'px');
      }

      // The intro entrance (collapsed menu → expands from the centre) should
      // only play at the very top of the page. If we're scrolled at all it's
      // ended immediately: the menu snaps to its final expanded state so it
      // never fights with the brand scroll animation below.
      var intro = header.classList.contains('header--intro');
      var menuWrap = header.querySelector('.header__menu-wrap');

      function endIntro() {
        if (!intro) return;
        intro = false;
        header.classList.remove('header--intro');
        // Re-measure now that the menu is at its full width, so the scroll shift
        // distances for D and P are correct.
        measure();
      }

      function onScroll() {
        if (intro && window.scrollY > 0) endIntro();
        var scrolled = window.scrollY > SCROLL_TRIGGER && desktop.matches;
        header.classList.toggle('header--scrolled', scrolled);
      }

      var ticking = false;
      function requestTick() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
      }

      measure();
      // Runs the "loaded part-way down the page" check too: onScroll ends the
      // intro right away if scrollY > 0.
      onScroll();

      // When the intro plays to completion at the top, re-measure once the menu
      // has finished expanding (this moves D and P). The intro class is left in
      // place — its `forwards` fill holds the final state, and a later scroll
      // ends it seamlessly via onScroll → endIntro.
      if (intro && menuWrap) {
        menuWrap.addEventListener('animationend', function (event) {
          if (event.animationName !== 'header-menu-reveal') return;
          measure();
          onScroll();
        });
      }

      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        onScroll();
      });
      if (desktop.addEventListener) {
        desktop.addEventListener('change', function () {
          measure();
          onScroll();
        });
      }
    }

    // Play the close animation before <details> collapses. Clicking the summary
    // normally toggles `open` instantly; when closing we cancel that, run the
    // conceal animation, then drop `open` once it ends.
    function setupMobileMenu(header) {
      var details = header.querySelector('.header__mobile');
      if (!details || details.dataset.mobileMenuInit) return;
      details.dataset.mobileMenuInit = 'true';

      var summary = details.querySelector('.header__mobile-toggle');
      var panel = details.querySelector('.header__mobile-panel');
      if (!summary || !panel) return;

      var reduce =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      summary.addEventListener('click', function (event) {
        // Only intercept the close (open → closed); let opening happen normally.
        if (!details.open || reduce) return;

        event.preventDefault();
        if (details.classList.contains('is-closing')) return;
        details.classList.add('is-closing');

        var closed = false;
        var done = function (e) {
          if (e && e.animationName !== 'mobile-panel-conceal') return;
          if (closed) return;
          closed = true;
          clearTimeout(fallback);
          panel.removeEventListener('animationend', done);
          details.classList.remove('is-closing');
          details.open = false;
        };
        // Fallback in case animationend never fires (e.g. panel not painted).
        var fallback = setTimeout(done, 500);
        panel.addEventListener('animationend', done);
      });
    }

    // "realne wspomnienie" toggle. The control lives in the header but drives the
    // memories section: it appears while any [data-memories] block is in view, and
    // flipping it on adds `.is-revealed` to those blocks (which drops the blur).
    function setupRevealToggle(header) {
      if (!header || header.dataset.revealToggleInit) return;

      var wrap = header.querySelector('[data-reveal-memories]');
      var sw = header.querySelector('[data-reveal-switch]');
      if (!wrap || !sw) return;

      header.dataset.revealToggleInit = 'true';

      function memories() {
        return document.querySelectorAll('[data-memories]');
      }

      function isOn() {
        return sw.getAttribute('aria-checked') === 'true';
      }

      function apply(on) {
        sw.setAttribute('aria-checked', on ? 'true' : 'false');
        memories().forEach(function (m) {
          m.classList.toggle('is-revealed', on);
        });
      }

      sw.addEventListener('click', function () {
        apply(!isOn());
      });

      // Without IntersectionObserver we can't track the section's position, so
      // just expose the control whenever a memories block exists on the page.
      if (!('IntersectionObserver' in window)) {
        if (memories().length) wrap.classList.add('is-visible');
        return;
      }

      var inView = new Set();
      // Collapse the observation area to a thin band at the very top of the
      // viewport, so a section only counts as "in view" once its top edge has
      // scrolled up to the top (i.e. the preceding section is gone) and until it
      // has fully scrolled past. rootMargin bottom -90% leaves a 10% band up top.
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              inView.add(entry.target);
            } else {
              inView.delete(entry.target);
            }
          });
          wrap.classList.toggle('is-visible', inView.size > 0);
        },
        { rootMargin: '0px 0px -90% 0px' }
      );

      var observed = new WeakSet();
      function wire() {
        memories().forEach(function (m) {
          if (observed.has(m)) return;
          observed.add(m);
          io.observe(m);
          // Keep a freshly-added section in sync with the current toggle state.
          m.classList.toggle('is-revealed', isOn());
        });
      }

      wire();
      // Theme editor: the memories section may be added or reloaded after the header.
      document.addEventListener('shopify:section:load', wire);
    }

    function init(scope) {
      (scope || document).querySelectorAll('.header').forEach(function (header) {
        setup(header);
        setupMobileMenu(header);
        setupRevealToggle(header);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-loader"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.documentElement;
    const loader = document.querySelector('[data-home-loader]');
    if (!loader) return;

    // Only run on a first visit — the boot script adds this class before paint.
    if (!root.classList.contains('home-loading')) return;

    const frames = Array.prototype.slice.call(loader.querySelectorAll('[data-frame]'));
    const yearEl = loader.querySelector('[data-loader-year]');
    const duration = parseInt(loader.getAttribute('data-frame-duration'), 10) || 120;
    let index = 0;

    function show(i) {
      frames.forEach(function (frame, n) {
        frame.classList.toggle('is-active', n === i);
      });
      let year = frames[i] && frames[i].getAttribute('data-year');
      if (yearEl && year) yearEl.textContent = year;
    }

    function finish() {
      try { sessionStorage.setItem('dp_home_loaded', '1'); } catch (e) {}
      loader.classList.add('is-done');
      let done = function () {
        root.classList.remove('home-loading');
        loader.removeEventListener('transitionend', done);
      };
      loader.addEventListener('transitionend', done);
      setTimeout(done, 700);
    }

    // Linger on the final photo so it can be taken in before the reveal.
    const HOLD_LAST = 1500;

    show(0);
    let timer = setInterval(function () {
      index++;
      if (index >= frames.length) {
        clearInterval(timer);
        setTimeout(finish, HOLD_LAST);
        return;
      }
      show(index);
    }, duration);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // One shared player for every memories section, so starting a voice note
    // always stops the one that was playing before.
    var player = null;
    var playingItem = null;
    var dragging = false;
    var SEEK_STEP = 5;
    // The one video currently playing with sound (also shared across sections).
    var soundItem = null;

    function videoOf(item) {
      return item.querySelector('[data-memory-video]');
    }

    // The media element a memory's seek bar drives: its own clip for a video,
    // the shared voice-note player only while that note is the active one.
    function mediaFor(item) {
      if (item.classList.contains('memories__item--video')) return videoOf(item);
      return item === playingItem ? player : null;
    }

    function setSound(item, on) {
      var video = videoOf(item);
      if (!video) return;
      if (on) {
        if (soundItem && soundItem !== item) setSound(soundItem, false);
        if (player && !player.paused) player.pause();
        soundItem = item;
        if (video.paused) playVideo(item);
      } else if (soundItem === item) {
        soundItem = null;
      }
      video.muted = !on;
      item.classList.toggle('is-sound-on', on);
      var btn = item.querySelector('[data-memory-sound]');
      if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function playVideo(item) {
      var video = videoOf(item);
      if (!video) return;
      item.classList.remove('is-paused');
      var toggle = item.querySelector('[data-memory-video-toggle]');
      if (toggle) toggle.setAttribute('aria-pressed', 'true');
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }

    function pauseVideo(item) {
      var video = videoOf(item);
      if (!video) return;
      item.classList.add('is-paused');
      var toggle = item.querySelector('[data-memory-video-toggle]');
      if (toggle) toggle.setAttribute('aria-pressed', 'false');
      video.pause();
    }

    function setPlaying(item, playing) {
      item.classList.toggle('is-playing', playing);
      var toggle = item.querySelector('[data-memory-audio-toggle]');
      if (toggle) toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
    }

    function setProgress(item, ratio) {
      item.style.setProperty('--memory-progress', ratio);
      var seek = item.querySelector('[data-memory-seek]');
      if (seek) seek.setAttribute('aria-valuenow', Math.round(ratio * 100));
    }

    function setActive(item, active) {
      item.classList.toggle('is-active', active);
      var seek = item.querySelector('[data-memory-seek]');
      if (seek) seek.tabIndex = active ? 0 : -1;
    }

    function setMuted(item, muted) {
      item.classList.toggle('is-muted', muted);
      var btn = item.querySelector('[data-memory-audio-mute]');
      if (btn) btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      if (item === playingItem && player) player.muted = muted;
    }

    function resetItem(item) {
      setPlaying(item, false);
      setActive(item, false);
      setMuted(item, false);
      item.style.removeProperty('--memory-progress');
      var seek = item.querySelector('[data-memory-seek]');
      if (seek) seek.setAttribute('aria-valuenow', '0');
    }

    function seekTo(item, ratio) {
      var media = mediaFor(item);
      if (!media || !media.duration) return;
      ratio = Math.min(Math.max(ratio, 0), 1);
      media.currentTime = ratio * media.duration;
      setProgress(item, ratio);
    }

    function getPlayer() {
      if (player) return player;
      player = new Audio();
      player.preload = 'none';
      player.addEventListener('timeupdate', function () {
        if (!playingItem || !player.duration || dragging) return;
        setProgress(playingItem, player.currentTime / player.duration);
      });
      player.addEventListener('play', function () {
        if (playingItem) setPlaying(playingItem, true);
      });
      player.addEventListener('pause', function () {
        if (playingItem) setPlaying(playingItem, false);
      });
      player.addEventListener('ended', function () {
        if (playingItem) resetItem(playingItem);
        playingItem = null;
      });
      return player;
    }

    function toggleAudio(item) {
      var src = item.getAttribute('data-memory-audio');
      if (!src) return;
      var audio = getPlayer();

      if (playingItem === item) {
        if (audio.paused && soundItem) setSound(soundItem, false);
        if (audio.paused) audio.play().catch(function () {});
        else audio.pause();
        return;
      }

      if (playingItem) {
        audio.pause();
        resetItem(playingItem);
      }
      // A voice note and a video with sound would talk over each other.
      if (soundItem) setSound(soundItem, false);
      playingItem = item;
      setActive(item, true);
      audio.muted = false;
      audio.src = src;
      audio.play().catch(function () {
        resetItem(item);
        if (playingItem === item) playingItem = null;
      });
    }

    function initMemories(scope) {
      (scope || document).querySelectorAll('[data-memories]').forEach(function (root) {
        if (root.dataset.memoriesInit) return;
        root.dataset.memoriesInit = 'true';

        var items = root.querySelectorAll('.memories__item');
        if (!items.length) return;

        // Once the pointer/focus leaves an item, hold its sharpened (unblurred)
        // state for a moment before letting it blur back in, so the memory stays
        // readable for a beat longer. The description text lingers on a much
        // shorter timer so it hides shortly after hover-out, well before the
        // image blurs back.
        var LINGER_MS = 3000;
        var TEXT_LINGER_MS = 20;
        items.forEach(function (item) {
          var timer = null;
          var textTimer = null;

          function keep() {
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
            if (textTimer) {
              clearTimeout(textTimer);
              textTimer = null;
            }
            item.classList.add('is-lingering', 'is-lingering-text');
          }

          function release() {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              item.classList.remove('is-lingering');
              timer = null;
            }, LINGER_MS);

            if (textTimer) clearTimeout(textTimer);
            textTimer = setTimeout(function () {
              item.classList.remove('is-lingering-text');
              textTimer = null;
            }, TEXT_LINGER_MS);
          }

          item.addEventListener('mouseenter', keep);
          item.addEventListener('mouseleave', release);
          item.addEventListener('focusin', keep);
          item.addEventListener('focusout', release);
        });

        // Background videos only play while on screen, so a long page of
        // blurred loops doesn't keep decoding video nobody can see. A clip the
        // visitor paused stays paused; one scrolled away loses its sound.
        var videos = root.querySelectorAll('[data-memory-video]');
        if (videos.length && 'IntersectionObserver' in window) {
          var videoObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              var item = v.closest('.memories__item');
              if (entry.isIntersecting) {
                if (item && item.classList.contains('is-paused')) return;
                var playing = v.play();
                if (playing && playing.catch) playing.catch(function () {});
              } else {
                if (item && item === soundItem) setSound(item, false);
                v.pause();
              }
            });
          }, { rootMargin: '200px 0px' });
          videos.forEach(function (v) {
            v.muted = true;
            videoObserver.observe(v);
          });
        }

        // Video player: the corner buttons pause/resume and toggle sound; the
        // progress bar follows playback. Clicking the clip itself opens the
        // lightbox (wired up below).
        root.querySelectorAll('.memories__item--video').forEach(function (item) {
          var video = videoOf(item);
          if (!video) return;
          video.addEventListener('timeupdate', function () {
            if (!video.duration || dragging) return;
            setProgress(item, video.currentTime / video.duration);
          });

          var toggle = item.querySelector('[data-memory-video-toggle]');
          if (toggle) {
            toggle.addEventListener('click', function () {
              if (item.classList.contains('is-paused')) playVideo(item);
              else pauseVideo(item);
            });
            toggle.addEventListener('mousedown', function (event) { event.preventDefault(); });
          }

          var sound = item.querySelector('[data-memory-sound]');
          if (sound) {
            sound.addEventListener('click', function () {
              setSound(item, !item.classList.contains('is-sound-on'));
            });
            sound.addEventListener('mousedown', function (event) { event.preventDefault(); });
          }
        });

        // Voice notes: clicking the photo plays/pauses. For notes and videos
        // alike the bar seeks and the pill tracks the pointer, nudged just
        // below-right of it like a tooltip.
        root.querySelectorAll('.memories__item--audio, .memories__item--video').forEach(function (item) {
          var toggle = item.querySelector('[data-memory-audio-toggle]');
          if (toggle) {
            toggle.addEventListener('click', function () { toggleAudio(item); });
            // Don't let a mouse click park focus on the photo: :focus-within
            // would keep the tile sharp (and the play icon up) after the pointer
            // leaves. Keyboard focus is unaffected.
            toggle.addEventListener('mousedown', function (event) { event.preventDefault(); });
          }

          var mute = item.querySelector('[data-memory-audio-mute]');
          if (mute) {
            mute.addEventListener('click', function () {
              setMuted(item, !item.classList.contains('is-muted'));
            });
            mute.addEventListener('mousedown', function (event) { event.preventDefault(); });
          }

          // Seek: click or drag along the bar; arrows step ±5s, Home/End jump.
          var seek = item.querySelector('[data-memory-seek]');
          if (seek) {
            var ratioAt = function (event) {
              var rect = seek.getBoundingClientRect();
              return (event.clientX - rect.left) / rect.width;
            };
            seek.addEventListener('pointerdown', function (event) {
              if (!mediaFor(item)) return;
              event.preventDefault();
              dragging = true;
              seek.classList.add('is-dragging');
              seek.setPointerCapture(event.pointerId);
              seekTo(item, ratioAt(event));
            });
            seek.addEventListener('pointermove', function (event) {
              if (dragging && seek.hasPointerCapture(event.pointerId)) seekTo(item, ratioAt(event));
            });
            var endDrag = function () {
              dragging = false;
              seek.classList.remove('is-dragging');
            };
            seek.addEventListener('pointerup', endDrag);
            seek.addEventListener('pointercancel', endDrag);
            seek.addEventListener('keydown', function (event) {
              var media = mediaFor(item);
              if (!media || !media.duration) return;
              var d = media.duration;
              var t = media.currentTime;
              if (event.key === 'ArrowRight' || event.key === 'ArrowUp') t += SEEK_STEP;
              else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') t -= SEEK_STEP;
              else if (event.key === 'Home') t = 0;
              else if (event.key === 'End') t = d;
              else return;
              event.preventDefault();
              seekTo(item, t / d);
            });
          }

          var pill = item.querySelector('.memories__cursor');
          if (!pill) return;
          item.addEventListener('pointermove', function (event) {
            if (event.pointerType !== 'mouse') return;
            var rect = item.getBoundingClientRect();
            pill.style.setProperty('--cursor-x', event.clientX - rect.left + 14 + 'px');
            pill.style.setProperty('--cursor-y', event.clientY - rect.top + 18 + 'px');
          });
        });

        // Lightbox: tapping an image opens an enlarged view of the photo.
        var lightbox = root.querySelector('[data-memories-lightbox]');
        if (lightbox) {
          var lbImage = lightbox.querySelector('[data-lightbox-image]');
          var lbVideo = lightbox.querySelector('[data-lightbox-video]');
          var lbCaption = lightbox.querySelector('[data-lightbox-caption]');
          var lbTitle = lightbox.querySelector('[data-lightbox-title]');
          var lbYear = lightbox.querySelector('[data-lightbox-year]');
          var lbDescription = lightbox.querySelector('[data-lightbox-description]');
          var lbClose = lightbox.querySelector('.memories__lightbox-close');
          var lastFocused = null;
          var closeTimer = null;
          var loadToken = 0;
          var preloaded = {};

          // Warm the browser cache with the full-size image so a later click
          // opens instantly instead of waiting on a fresh download.
          function preload(trigger) {
            var full = trigger.getAttribute('data-full-src');
            if (!full || preloaded[full]) return;
            preloaded[full] = true;
            var pre = new Image();
            pre.src = full;
          }

          // Load the memory's clip into the lightbox player (same sources as
          // the tile, which picks the best format) and start it with sound.
          function showVideo(trigger) {
            var tileVideo = trigger.querySelector('video');
            lbVideo.innerHTML = '';
            if (tileVideo) {
              tileVideo.querySelectorAll('source').forEach(function (source) {
                lbVideo.appendChild(source.cloneNode(true));
              });
              if (tileVideo.poster) lbVideo.poster = tileVideo.poster;
            }
            lbVideo.preload = 'auto';
            lbVideo.muted = false;
            lbVideo.load();
            var playing = lbVideo.play();
            if (playing && playing.catch) playing.catch(function () {});
          }

          function resetVideo() {
            if (!lbVideo) return;
            lbVideo.pause();
            lbVideo.innerHTML = '';
            lbVideo.removeAttribute('poster');
            lbVideo.preload = 'none';
            lbVideo.load();
          }

          function openLightbox(trigger) {
            var isVideo = trigger.hasAttribute('data-memory-video-open') && lbVideo;
            var img = trigger.querySelector('img');
            var full = trigger.getAttribute('data-full-src');
            var thumb = (img && (img.currentSrc || img.src)) || '';

            // Show the already-downloaded thumbnail immediately (scaled up), then
            // swap in the hi-res version once it loads — so the view is never
            // blank. The token guards against a slow load landing after the user
            // has moved on to a different image or closed the lightbox.
            var token = ++loadToken;
            lbImage.hidden = !!isVideo;
            if (lbVideo) lbVideo.hidden = !isVideo;
            if (isVideo) {
              // Nothing else should talk over the clip.
              if (player && !player.paused) player.pause();
              if (soundItem) setSound(soundItem, false);
              resetVideo();
              showVideo(trigger);
            } else {
              lbImage.src = thumb || full;
              lbImage.alt = (img && img.alt) || '';
            }

            if (lbCaption) {
              var title = trigger.getAttribute('data-title') || '';
              var year = trigger.getAttribute('data-year') || '';
              var caption = trigger.getAttribute('data-caption') || '';
              if (lbTitle) lbTitle.textContent = title;
              if (lbYear) lbYear.textContent = year === '' ? '' : '[' + year + ']';
              if (lbDescription) lbDescription.innerHTML = caption;
              lbCaption.hidden = title === '' && year === '' && caption === '';
            }
            if (!isVideo && full && full !== thumb) {
              var hi = new Image();
              hi.onload = function () {
                if (token === loadToken && !lightbox.hidden) lbImage.src = full;
              };
              hi.src = full;
            }

            if (closeTimer) {
              clearTimeout(closeTimer);
              closeTimer = null;
            }
            lastFocused = document.activeElement;
            lightbox.hidden = false;
            // Force a reflow so the opening transition runs from the hidden state.
            void lightbox.offsetWidth;
            lightbox.classList.add('is-open');
            document.body.classList.add('memories-lightbox-open');
            if (lbClose) lbClose.focus();
          }

          function closeLightbox() {
            resetVideo();
            lightbox.classList.remove('is-open');
            document.body.classList.remove('memories-lightbox-open');
            closeTimer = setTimeout(function () {
              lightbox.hidden = true;
              lbImage.removeAttribute('src');
              lbImage.hidden = false;
              if (lbVideo) lbVideo.hidden = true;
              if (lbCaption) {
                if (lbTitle) lbTitle.textContent = '';
                if (lbYear) lbYear.textContent = '';
                if (lbDescription) lbDescription.innerHTML = '';
                lbCaption.hidden = true;
                lbCaption.style.width = '';
              }
              closeTimer = null;
            }, 320);
            if (lastFocused && lastFocused.focus) lastFocused.focus();
          }

          root.querySelectorAll('[data-memory-video-open]').forEach(function (btn) {
            btn.addEventListener('click', function () { openLightbox(btn); });
          });

          root.querySelectorAll('[data-memory-trigger]').forEach(function (btn) {
            btn.addEventListener('click', function () { openLightbox(btn); });
            btn.addEventListener('mouseenter', function () { preload(btn); });
            btn.addEventListener('focus', function () { preload(btn); });
            btn.addEventListener('touchstart', function () { preload(btn); }, { passive: true });
          });

          lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
            el.addEventListener('click', closeLightbox);
          });

          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
          });
        }

        // The scroll-triggered fade + rise for the heading words and gallery
        // items is handled by the shared `.reveal` engine (snippets/scroll-reveal).
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initMemories(); });
    } else {
      initMemories();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initMemories(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mountCarousel(root) {
      if (root.dataset.musicCarouselInit) return;

      var splideRoot = root.querySelector('.splide');
      if (!splideRoot) return;

      // Wait for the (deferred) Splide library before mounting; the load order of
      // this bundled script vs. the library's <script defer> isn't guaranteed.
      // Retry per-element (not via querySelectorAll on `root`, which only matches
      // descendants and would never re-find the root itself).
      if (typeof window.Splide === 'undefined') {
        window.setTimeout(function () { mountCarousel(root); }, 50);
        return;
      }

      root.dataset.musicCarouselInit = 'true';

      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var itemSize = parseInt(root.dataset.itemSize, 10);
      var itemSizeMobile = parseInt(root.dataset.itemSizeMobile, 10);
      var speed = parseFloat(root.dataset.autoscrollSpeed);
      if (!speed || speed <= 0) speed = 1;

      var splide = new window.Splide(splideRoot, {
        type: 'loop',
        drag: 'free',
        gap: '2.5rem',
        fixedWidth: itemSize ? itemSize + 'px' : '20rem',
        arrows: false,
        pagination: false,
        flickMaxPages: 2,
        // Below 768px: merchant-configurable card width with a tighter gap.
        breakpoints: {
          767: {
            fixedWidth: itemSizeMobile ? itemSizeMobile + 'px' : '240px',
            gap: '24px',
          },
        },
        // NB: the option key is `autoScroll` (lowercase) — the AutoScroll
        // extension reads `options.autoScroll`; `AutoScroll` is silently ignored.
        autoScroll: {
          speed: speed,
          pauseOnHover: true,
          pauseOnFocus: false,
          rewind: false,
        },
      });

      // Continuous auto-scroll only when motion is allowed; drag works either way.
      var extensions = {};
      if (!reduced && window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll) {
        extensions.AutoScroll = window.splide.Extensions.AutoScroll;
      }

      splide.mount(extensions);

      // Pause the auto-scroll while the section is off-screen to save CPU.
      if (extensions.AutoScroll && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var autoScroll = splide.Components.AutoScroll;
              if (!autoScroll) return;
              if (entry.isIntersecting) {
                autoScroll.play();
              } else {
                autoScroll.pause();
              }
            });
          },
          { threshold: 0 }
        );
        io.observe(root);
      }
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-music-carousel]').forEach(mountCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const dialog = document.querySelector('[data-password-dialog]');
    if (!dialog) return;

    const openButton = document.querySelector('[data-password-open]');
    if (openButton) {
      openButton.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    }

    // Click on the backdrop (outside the dialog box) closes it.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    // Reopen automatically after a wrong password so the visitor sees the error.
    if (dialog.querySelector('[data-password-error]') && typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-quantity]').forEach((wrap) => {
    const input = wrap.querySelector('.product__quantity-input');
    if (!input) return;

    wrap.querySelector('[data-quantity-decrement]')?.addEventListener('click', () => {
      const min = parseInt(input.min || '1', 10);
      const val = Math.max(min, parseInt(input.value || '1', 10) - 1);
      input.value = val;
    });

    wrap.querySelector('[data-quantity-increment]')?.addEventListener('click', () => {
      const val = parseInt(input.value || '1', 10) + 1;
      input.value = val;
    });
  });

  // Update the displayed price when the selected variant changes.
  const priceEl = document.querySelector('.product__price');
  document.querySelectorAll('.product__form input[name="id"]').forEach((input) => {
    input.addEventListener('change', () => {
      if (priceEl && input.dataset.price) priceEl.innerHTML = input.dataset.price;
    });
  });

  // Gallery thumbnails. Desktop: images stack vertically and the page scrolls,
  // so a thumb click scrolls the page to that image and the active thumb tracks
  // whichever image is nearest the viewport's vertical centre. Mobile: the media
  // is a horizontal scroll-snap slider, so we sync with its scrollLeft instead.
  (function () {
    const track = document.querySelector('[data-product-media]');
    const thumbsWrap = document.querySelector('[data-product-thumbs]');
    if (!track || !thumbsWrap) return;

    const thumbs = Array.from(thumbsWrap.querySelectorAll('.product__media-thumb'));
    const slides = Array.from(track.querySelectorAll('.product__media-item'));
    if (!thumbs.length || !slides.length) return;

    const desktop = window.matchMedia('(min-width: 990px)');
    let active = -1;

    function setActive(index) {
      if (index === active) return;
      active = index;
      thumbs.forEach((thumb, i) => {
        const isActive = i === index;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    // Mobile: which slide is snapped into view.
    function updateFromTrack() {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      setActive(Math.max(0, Math.min(slides.length - 1, index)));
    }

    // Desktop: which stacked image is closest to the viewport's vertical centre.
    function updateFromViewport() {
      const mid = window.innerHeight / 2;
      let best = 0;
      let bestDist = Infinity;
      slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();
        const dist = Math.abs(rect.top + rect.height / 2 - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      setActive(best);
    }

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (desktop.matches) {
          updateFromViewport();
        } else {
          updateFromTrack();
        }
        ticking = false;
      });
    }

    track.addEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        if (desktop.matches) {
          slides[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        }
        setActive(i);
      });
    });

    // Set the initial active thumb for the current layout.
    if (desktop.matches) {
      updateFromViewport();
    } else {
      updateFromTrack();
    }
  })();

  // Size-guide modal: open from the trigger, close via button, backdrop click,
  // or Escape (the native <dialog> handles Escape and focus trapping).
  (function () {
    const dialog = document.querySelector('[data-size-guide-dialog]');
    const openers = document.querySelectorAll('[data-size-guide-open]');
    if (!dialog || !openers.length) return;

    function open() {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function close() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    openers.forEach((btn) => btn.addEventListener('click', open));
    dialog
      .querySelectorAll('[data-size-guide-close]')
      .forEach((btn) => btn.addEventListener('click', close));

    // Close when the backdrop (the dialog element itself) is clicked.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
  })();

  // Add to cart without a page reload, then open the cart drawer.
  const productForm = document.querySelector('.product__form');
  if (productForm) {
    productForm.addEventListener('submit', async (event) => {
      // No JS drawer available → let the form submit normally.
      if (!window.CartDrawer) return;

      event.preventDefault();
      const submit = productForm.querySelector('.product__submit');
      const formData = new FormData(productForm);
      formData.append('sections', 'cart-drawer');
      submit?.setAttribute('disabled', '');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          // GA4 dataLayer: add_to_cart. `data` is the added line item from
          // /cart/add.js — `id` is the variant id, prices are in cents.
          const price = (data.final_price || 0) / 100;
          const quantity = data.quantity || 1;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: productForm.closest('.product')?.dataset.currency,
              value: price * quantity,
              items: [
                {
                  item_id: String(data.id),
                  item_name: data.product_title,
                  price: price,
                  quantity: quantity,
                },
              ],
            },
          });

          window.CartDrawer.renderFromSections(data.sections);
          window.CartDrawer.open();
        } else {
          console.warn('Add to cart failed:', data.description || data);
        }
      } catch (error) {
        // Network/parse failure — fall back to a full-page add.
        productForm.submit();
      } finally {
        submit?.removeAttribute('disabled');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-slide]'));
      this.pages = Array.from(root.querySelectorAll('[data-slide-to]'));
      this.index = 0;
      this.timer = null;
      this.interval = (parseInt(root.dataset.autoplayInterval, 10) || 6) * 1000;
      this.autoplay = root.hasAttribute('data-autoplay');

      if (this.slides.length < 2) return;

      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.pages.forEach((page) => {
        page.addEventListener('click', () => {
          this.goTo(parseInt(page.dataset.slideTo, 10));
          this.restart();
        });
      });

      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => this.start());
      this.root.addEventListener('focusin', () => this.stop());
      this.root.addEventListener('focusout', () => this.start());

      this.start();
      this.deferAutoplayUntilLoaded();
    }

    // The homepage intro loader marks <html> with `home-loading` until it
    // finishes (or a safety timeout clears it). While that class is present the
    // slideshow is hidden, so hold autoplay until it clears — otherwise slides
    // advance unseen behind the overlay. If there's no loader the class is
    // absent and this is a no-op, so autoplay starts immediately.
    deferAutoplayUntilLoaded() {
      const root = document.documentElement;
      if (!root.classList.contains('home-loading')) return;

      const observer = new MutationObserver(() => {
        if (!root.classList.contains('home-loading')) {
          observer.disconnect();
          this.start();
        }
      });
      observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    }

    goTo(index) {
      if (index === this.index) return;
      const total = this.slides.length;
      this.index = (index + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.pages.forEach((page, i) => {
        const active = i === this.index;
        page.classList.toggle('is-active', active);
        if (active) {
          page.setAttribute('aria-current', 'true');
        } else {
          page.removeAttribute('aria-current');
        }
      });
    }

    next() {
      this.goTo(this.index + 1);
    }

    start() {
      if (!this.autoplay || this.prefersReducedMotion || this.timer) return;
      // Don't run while the homepage intro loader is still covering the page.
      if (document.documentElement.classList.contains('home-loading')) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  function initSlideshows(scope) {
    (scope || document).querySelectorAll('[data-slideshow]').forEach((el) => {
      if (el.dataset.slideshowInit) return;
      el.dataset.slideshowInit = 'true';
      new Slideshow(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSlideshows());
  } else {
    initSlideshows();
  }

  // Re-initialise sections that the theme editor injects/reloads dynamically.
  document.addEventListener('shopify:section:load', (event) => {
    initSlideshows(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tour-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mountSlider(root) {
      if (root.dataset.tourSliderInit) return;

      // Wait for the (deferred) Splide library; load order of this bundled script
      // vs. the library's <script defer> isn't guaranteed. Retry per-element.
      if (typeof window.Splide === 'undefined') {
        window.setTimeout(function () { mountSlider(root); }, 50);
        return;
      }

      root.dataset.tourSliderInit = 'true';

      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var splide = new window.Splide(root, {
        type: 'loop',
        drag: 'free',
        autoWidth: true,
        arrows: false,
        pagination: false,
        gap: '3rem',
        breakpoints: {
          1000: { gap: '2rem' },
          750: { gap: '1rem' },
        },
        // Slow, continuous drift; visitors can still grab and drag it any time.
        autoScroll: {
          speed: 0.6,
          pauseOnHover: true,
          pauseOnFocus: false,
          rewind: false,
        },
      });

      // Auto-scroll only when motion is allowed; drag works either way.
      var extensions = {};
      if (!reduced && window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll) {
        extensions.AutoScroll = window.splide.Extensions.AutoScroll;
      }

      splide.mount(extensions);

      // Pause the auto-scroll while the section is off-screen to save CPU.
      if (extensions.AutoScroll && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var autoScroll = splide.Components.AutoScroll;
              if (!autoScroll) return;
              if (entry.isIntersecting) {
                autoScroll.play();
              } else {
                autoScroll.pause();
              }
            });
          },
          { threshold: 0 }
        );
        io.observe(root);
      }
    }

    // Featured (split layout): clicking a colour swatch swaps the product image,
    // price and link to the matching variant. Degrades to plain swatches without JS.
    function mountFeatured(root) {
      if (root.dataset.featuredInit) return;
      root.dataset.featuredInit = 'true';

      var swatches = root.querySelectorAll('[data-swatch]');
      if (!swatches.length) return;

      var image = root.querySelector('.tour-featured__base');
      var priceEl = root.querySelector('[data-featured-price]');
      var linkEl = root.querySelector('[data-featured-link]');

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var src = swatch.getAttribute('data-src');
          if (image && src) {
            image.style.opacity = '0';
            var swap = function () {
              image.setAttribute('src', src);
              image.removeAttribute('srcset');
              image.style.opacity = '';
            };
            if ('decode' in image) {
              var probe = new Image();
              probe.src = src;
              probe.decode().then(swap).catch(swap);
            } else {
              swap();
            }
          }

          var price = swatch.getAttribute('data-price');
          if (priceEl && price) priceEl.textContent = price;

          var url = swatch.getAttribute('data-url');
          if (linkEl && url) linkEl.setAttribute('href', url);

          swatches.forEach(function (other) {
            other.setAttribute('aria-checked', other === swatch ? 'true' : 'false');
          });
        });
      });
    }

    // "View product" pill tracks the cursor inside each slider tile. Delegated
    // on the slider root so it also covers the slides Splide clones for its loop.
    // The label is positioned via CSS transform from --label-x / --label-y (px),
    // nudged just below-right of the pointer so it reads like a tooltip.
    function mountSliderLabels(root) {
      if (root.dataset.labelInit) return;
      root.dataset.labelInit = 'true';

      root.addEventListener('pointermove', function (event) {
        var media = event.target.closest && event.target.closest('.tour-slider__media');
        if (!media) return;

        var label = media.querySelector('.tour-slider__label');
        if (!label) return;

        var rect = media.getBoundingClientRect();
        label.style.setProperty('--label-x', event.clientX - rect.left + 14 + 'px');
        label.style.setProperty('--label-y', event.clientY - rect.top + 18 + 'px');
      });
    }

    function scan(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-tour-slider]').forEach(mountSlider);
      root.querySelectorAll('[data-tour-slider]').forEach(mountSliderLabels);
      root.querySelectorAll('[data-featured]').forEach(mountFeatured);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
